exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "ul.downloads{padding:0}.pptx-btn{text-align:center;padding:10px;background:#ea3e23;color:#FFFFFF}.pptx-btn i{display:block;margin-bottom:.5em}\n", ""]);
